/**
 * Revelar uma cerca na listagem (MK-21221): as duas contas que isso exige, puras e testáveis.
 *
 * Existem separadas do componente pelo mesmo motivo do `mapFocus.js`: nenhum componente deste módulo
 * é montável no Jest (a cadeia do `BasePageLayout` traz `jose`, que é ESM puro), então decisão que
 * mora dentro de `.vue` não tem gate de CI nenhum. Aqui a regra fica coberta; ao componente sobra
 * medir o DOM e escrever `scrollTop`.
 */

/**
 * Em que página do scroll infinito está o item de índice `indice`.
 *
 * A paginação da listagem é client-side (`visibleFences = sortedFences.slice(0, page * pageSize)`),
 * então "carregar as páginas necessárias" é só levantar `page` até cobrir o índice. 1-based porque é
 * assim que `page` nasce no store.
 */
export const paginaComIndice = (indice, pageSize) => {
  if (!Number.isFinite(indice) || indice < 0) return 1
  const tamanho = Number(pageSize) > 0 ? Number(pageSize) : 1
  return Math.floor(indice / tamanho) + 1
}

/**
 * Novo `scrollTop` do container para o item ficar visível, rolando o MÍNIMO possível.
 *
 * "Mínimo" é requisito do card ("cerca visível na lista: scroll mínimo ou nenhum"), e é o que evita
 * que a lista dê um pulo quando a cerca clicada já estava na tela.
 *
 * `itemTop` é a distância do topo do item ao topo do CONTEÚDO do container (não à viewport dele):
 * medir por `getBoundingClientRect` dos dois e somar o `scrollTop` atual, em vez de `offsetTop`, que
 * depende de quem é o `offsetParent`.
 *
 * NÃO use `scrollIntoView` para isto neste repo: ele rola os ancestrais também, e no v3 quem rola a
 * página é o `.vue3-wrapper` do host v2 (`overflow-y: auto`), então a tela inteira pode saltar junto.
 * Escrevendo `scrollTop` do container, o efeito fica contido nele.
 */
export const scrollTopParaRevelar = ({ scrollTop = 0, alturaVisivel = 0, itemTop = 0, itemAltura = 0, margem = 0 }) => {
  const atual = Math.max(0, Number(scrollTop) || 0)
  const visivel = Math.max(0, Number(alturaVisivel) || 0)
  const top = Number(itemTop) || 0
  const altura = Math.max(0, Number(itemAltura) || 0)
  const folga = Math.max(0, Number(margem) || 0)

  // Item mais alto que a área visível: alinhar pelo topo é o único enquadramento útil (mostrar o fim
  // dele esconderia o começo, que é onde estão nome e status).
  if (altura + folga * 2 >= visivel) return Math.max(0, top - folga)

  const acimaDaVista = top - folga < atual
  if (acimaDaVista) return Math.max(0, top - folga)

  const abaixoDaVista = top + altura + folga > atual + visivel
  if (abaixoDaVista) return Math.max(0, top + altura + folga - visivel)

  // Já inteiramente visível: não mexer. É este caso que faz "scroll mínimo ou nenhum" valer.
  return atual
}
